import { AutogenModelOpenItem, AutogenRowOpenItem } from "./autogen/AutogenModelOpenItem";

export class ModelOpenItem extends AutogenModelOpenItem<RowOpenItem> {
	constructor() {
		super(RowOpenItem);
	}
}

export class RowOpenItem extends AutogenRowOpenItem {
}